import { HttpClientModule } from '@angular/common/http';
import { Component } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [RouterOutlet, RouterLink, RouterLinkActive, HttpClientModule, MatIconModule],
	providers: [MatIconRegistry],
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
})
export class AppComponent {
	constructor(
		private matIconRegistry: MatIconRegistry,
		private domSanitizer: DomSanitizer,
	) {
		this.matIconRegistry.addSvgIcon(
			'progress-check',
			this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/svg/progress-check.svg'),
		);
	}
}
